import { useEffect, useState } from "react";

const ButtonList = ({ values, setField }) => {
    const [buttons, setButtons] = useState([]);
    
    useEffect(() => {
        if (!Array.isArray(values) || values.length === 0) {
            setButtons([]);
            return;
        }

        const temp = values.map(value => (
            <button 
                key={value} 
                onClick={() => setField(value)}
                className="select-button"
            >
                {value}
            </button>
        ));
        
        setButtons(temp);
    }, [values, setField]); 
    
    return (
        <div className="selection-list">
            {buttons}
        </div>
    );
}
export default ButtonList;